import API from '../../../../api'
import { useState } from 'react'
import { useMap } from 'react-leaflet'

export default function useSelectShop() {
  const map = useMap()
  const [selectedShop, setSelectedShop] = useState(null)

  const adjustMapHeight = () => {
    const selectedShopElem = document.querySelector(
      '.map-wrapper .operator-item'
    )
    const mapWrapper = document.querySelector('.map-wrapper')
    if(
      selectedShopElem &&
      mapWrapper &&
      selectedShopElem.clientHeight >= mapWrapper.clientHeight - 20
    ) {
      mapWrapper.style.height = `${selectedShopElem.clientHeight + 20}px`
    }
  }
  const getShopInfo = (shop, slug) => {
    API(`collections/${slug}/items/${shop.id}/`)
      .get()
      .then((result) => {
        setSelectedShop(result)
        if(map) {
          map.panTo([shop.point.latitude, shop.point.longitude])
          adjustMapHeight()
        }
      })
  }

  const closePopup = () => {
    setSelectedShop(null)
  }

  return {
    getShopInfo,
    selectedShop,
    setSelectedShop,
    closePopup,
  }
}
